export const LINK_NAME = "Einladungslink";
export const LINK_TOOLTIP = "In Zwischenablage kopieren";
export const LINK_TOOLTIP_CLICKED =
  "Der Link wurde in die Zwischenablage kopiert";
